class Radios extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.current_value = this.querySelector(".radios--option-current")),
      (this.inputs = this.querySelectorAll("input")),
      (this.is_swatches = "true" === this.getAttribute("data-is-swatches")),
      this.preventFormSubmitOnEnter(),
      this.is_swatches &&
        (theme.utils.setSwatchColors(this.inputs), this.current_value) &&
        this.updateLabelOnChange();
      this.updateLabelOnChange(); // This line is custom code
  }
  disconnectedCallback() {
    this.inputs.off("keydown.Radios change.Radios");
  }
  preventFormSubmitOnEnter() {
    this.inputs.on("keydown.Radios", (t) => {
      "Enter" === t.key && t.preventDefault();
    });
  }
  updateLabelOnChange() {
    this.inputs.on("change.Radios", (t) => {
      this.current_value.textContent = t.target.value;
    });
  }
}
customElements.define("radios-root", Radios);
